// Propósito declarado (X-Purpose) vigente por 15 minutos para o mesmo contexto (Parte 14.2).
import type { DeclaredPurpose } from '@giyus/api-client';
import { create } from 'zustand';

export const PURPOSE_TTL_MS = 15 * 60 * 1000;

/** Catálogo de propósitos do Anexo E.2 (`authz.PurposeCode`; `Other` exige texto — validado pelo servidor). */
export const PURPOSE_CODES = [
  'VisitConfirmation',
  'ClinicalCare',
  'StudySetup',
  'QualityAudit',
  'PrivacyRequest',
  'Export',
  'Support',
  'LegalRequest',
  'Other',
] as const;
export type PurposeCode = (typeof PURPOSE_CODES)[number];

interface PurposeState {
  readonly purpose: DeclaredPurpose | null;
  readonly contextKey: string | null;
  readonly expiresAt: number;
  readonly declare: (purpose: DeclaredPurpose, contextKey: string, now?: number) => void;
  readonly clear: () => void;
}

export const usePurposeStore = create<PurposeState>((set) => ({
  purpose: null,
  contextKey: null,
  expiresAt: 0,
  declare: (purpose, contextKey, now = Date.now()) => {
    set({ purpose, contextKey, expiresAt: now + PURPOSE_TTL_MS });
  },
  clear: () => {
    set({ purpose: null, contextKey: null, expiresAt: 0 });
  },
}));

/** Propósito ainda válido (não expirado); `null` caso contrário. Lido pelo middleware `X-Purpose`. */
export function readValidPurpose(now = Date.now()): DeclaredPurpose | null {
  const { purpose, expiresAt } = usePurposeStore.getState();
  return purpose && expiresAt > now ? purpose : null;
}

/** Invalida o propósito quando o contexto ativo muda (tenant/estudo). */
export function invalidatePurposeForContext(contextKey: string): void {
  const state = usePurposeStore.getState();
  if (state.contextKey !== null && state.contextKey !== contextKey) {
    state.clear();
  }
}
